module.exports = __webpack_public_path__ + "static/media/6c.b27ed10b.png";